import styled from "styled-components/macro";
import { Link } from "react-router-dom";


export const WaveImg = styled.img`
width: 500px;
height: 60px;
grid-area: wave1;

`; 

export const LinkTest = styled(Link)`
grid-area: wave1;
cursor: pointer;


`